import _findKey from "lodash/findKey";
/* eslint-disable no-param-reassign */
import "core-js/modules/es6.function.name.js";
import FastqFileType from 'const/enums/FastqFileType';
import produce, { current } from 'immer';
import { getPairData } from 'utils/fastqUtils';
var cleanupPairMatches = function cleanupPairMatches(draft, file, secondaryAnalysisId) {
  var _getPairData = getPairData(file.name),
    subName = _getPairData.name;
  var pairKey = null;
  if (file.type === FastqFileType.IMMUNE_FASTQ) {
    // immune are keys so easy to find
    pairKey = subName;
  } else if (file.type === FastqFileType.WT_FASTQ) {
    // wt are values so need to find the value that matches the subName
    pairKey = _findKey(current(draft[secondaryAnalysisId].files.pairMatches), function (currSubName) {
      return currSubName === subName;
    });
  }
  if (pairKey === null) return;
  delete draft[secondaryAnalysisId].files.pairMatches[pairKey];
};
var secondaryAnalysisFileDeleted = produce(function (draft, action) {
  var _action$payload = action.payload,
    secondaryAnalysisId = _action$payload.secondaryAnalysisId,
    fileId = _action$payload.fileId;
  var file = current(draft[secondaryAnalysisId].files.data[fileId]);
  delete draft[secondaryAnalysisId].files.data[fileId];
  cleanupPairMatches(draft, file, secondaryAnalysisId);
});
export default secondaryAnalysisFileDeleted;